// source: witbooking/backoffice/accommodation/v1/accommodation_api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var validate_validate_pb = require('../../../../validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
var witbooking_backoffice_common_common_pb = require('../../../../witbooking/backoffice/common/common_pb.js');
goog.object.extend(proto, witbooking_backoffice_common_common_pb);
goog.exportSymbol('proto.witbooking.backoffice.accommodation.v1.Accommodation', null, global);
goog.exportSymbol('proto.witbooking.backoffice.accommodation.v1.AccommodationOccupancy', null, global);
goog.exportSymbol('proto.witbooking.backoffice.accommodation.v1.CategoryExtraPrice', null, global);
goog.exportSymbol('proto.witbooking.backoffice.accommodation.v1.CategoryExtraPrice.ValueCase', null, global);
goog.exportSymbol('proto.witbooking.backoffice.accommodation.v1.CategoryExtraRateType', null, global);
goog.exportSymbol('proto.witbooking.backoffice.accommodation.v1.CategoryExtraUnitType', null, global);
goog.exportSymbol('proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput', null, global);
goog.exportSymbol('proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView', null, global);
goog.exportSymbol('proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine', null, global);
goog.exportSymbol('proto.witbooking.backoffice.accommodation.v1.CategoryLimitsInput', null, global);
goog.exportSymbol('proto.witbooking.backoffice.accommodation.v1.CreateAccommodationRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.accommodation.v1.CreateAccommodationResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimit', null, global);
goog.exportSymbol('proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimits', null, global);
goog.exportSymbol('proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.accommodation.v1.GetAccommodationRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.accommodation.v1.GetAccommodationResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.accommodation.v1.GetAccommodationsRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.accommodation.v1.GetAccommodationsResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.accommodation.v1.MaxOccupancyByType', null, global);
goog.exportSymbol('proto.witbooking.backoffice.accommodation.v1.Multimedia', null, global);
goog.exportSymbol('proto.witbooking.backoffice.accommodation.v1.MultimediaTranslation', null, global);
goog.exportSymbol('proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.accommodation.v1.Translation', null, global);
goog.exportSymbol('proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.accommodation.v1.CreateAccommodationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.accommodation.v1.CreateAccommodationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.accommodation.v1.CreateAccommodationRequest.displayName = 'proto.witbooking.backoffice.accommodation.v1.CreateAccommodationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.accommodation.v1.CreateAccommodationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.accommodation.v1.CreateAccommodationResponse.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.accommodation.v1.CreateAccommodationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.accommodation.v1.CreateAccommodationResponse.displayName = 'proto.witbooking.backoffice.accommodation.v1.CreateAccommodationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationRequest.displayName = 'proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationResponse.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationResponse.displayName = 'proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationRequest.displayName = 'proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationResponse.displayName = 'proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationRequest.displayName = 'proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationResponse.displayName = 'proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.accommodation.v1.GetAccommodationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.accommodation.v1.GetAccommodationRequest.displayName = 'proto.witbooking.backoffice.accommodation.v1.GetAccommodationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.accommodation.v1.GetAccommodationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.accommodation.v1.GetAccommodationResponse.displayName = 'proto.witbooking.backoffice.accommodation.v1.GetAccommodationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.accommodation.v1.GetAccommodationsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.accommodation.v1.GetAccommodationsRequest.displayName = 'proto.witbooking.backoffice.accommodation.v1.GetAccommodationsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.accommodation.v1.GetAccommodationsResponse.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.accommodation.v1.GetAccommodationsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.accommodation.v1.GetAccommodationsResponse.displayName = 'proto.witbooking.backoffice.accommodation.v1.GetAccommodationsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.accommodation.v1.Translation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.accommodation.v1.Translation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.accommodation.v1.Translation.displayName = 'proto.witbooking.backoffice.accommodation.v1.Translation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.accommodation.v1.MultimediaTranslation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.accommodation.v1.MultimediaTranslation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.accommodation.v1.MultimediaTranslation.displayName = 'proto.witbooking.backoffice.accommodation.v1.MultimediaTranslation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.accommodation.v1.Multimedia = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.accommodation.v1.Multimedia.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.accommodation.v1.Multimedia, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.accommodation.v1.Multimedia.displayName = 'proto.witbooking.backoffice.accommodation.v1.Multimedia';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.accommodation.v1.Accommodation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.accommodation.v1.Accommodation.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.accommodation.v1.Accommodation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.accommodation.v1.Accommodation.displayName = 'proto.witbooking.backoffice.accommodation.v1.Accommodation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.accommodation.v1.MaxOccupancyByType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.accommodation.v1.MaxOccupancyByType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.accommodation.v1.MaxOccupancyByType.displayName = 'proto.witbooking.backoffice.accommodation.v1.MaxOccupancyByType';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.accommodation.v1.AccommodationOccupancy = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.accommodation.v1.AccommodationOccupancy, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.accommodation.v1.AccommodationOccupancy.displayName = 'proto.witbooking.backoffice.accommodation.v1.AccommodationOccupancy';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsInput = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.accommodation.v1.CategoryLimitsInput.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.accommodation.v1.CategoryLimitsInput, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.accommodation.v1.CategoryLimitsInput.displayName = 'proto.witbooking.backoffice.accommodation.v1.CategoryLimitsInput';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput.displayName = 'proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsRequest.displayName = 'proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsResponse.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsResponse.displayName = 'proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView.displayName = 'proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine.displayName = 'proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.accommodation.v1.CategoryExtraPrice = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.witbooking.backoffice.accommodation.v1.CategoryExtraPrice.oneofGroups_);
};
goog.inherits(proto.witbooking.backoffice.accommodation.v1.CategoryExtraPrice, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.accommodation.v1.CategoryExtraPrice.displayName = 'proto.witbooking.backoffice.accommodation.v1.CategoryExtraPrice';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsRequest.displayName = 'proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsResponse.displayName = 'proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimits = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimits.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimits, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimits.displayName = 'proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimits';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimit = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimit.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimit, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimit.displayName = 'proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimit';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.accommodation.v1.CreateAccommodationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.accommodation.v1.CreateAccommodationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.accommodation.v1.CreateAccommodationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.CreateAccommodationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    accommodation: (f = msg.getAccommodation()) && proto.witbooking.backoffice.accommodation.v1.Accommodation.toObject(includeInstance, f),
    categoryLimits: (f = msg.getCategoryLimits()) && proto.witbooking.backoffice.accommodation.v1.CategoryLimitsInput.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.accommodation.v1.CreateAccommodationRequest}
 */
proto.witbooking.backoffice.accommodation.v1.CreateAccommodationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.accommodation.v1.CreateAccommodationRequest;
  return proto.witbooking.backoffice.accommodation.v1.CreateAccommodationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.accommodation.v1.CreateAccommodationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.accommodation.v1.CreateAccommodationRequest}
 */
proto.witbooking.backoffice.accommodation.v1.CreateAccommodationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.accommodation.v1.Accommodation;
      reader.readMessage(value,proto.witbooking.backoffice.accommodation.v1.Accommodation.deserializeBinaryFromReader);
      msg.setAccommodation(value);
      break;
    case 2:
      var value = new proto.witbooking.backoffice.accommodation.v1.CategoryLimitsInput;
      reader.readMessage(value,proto.witbooking.backoffice.accommodation.v1.CategoryLimitsInput.deserializeBinaryFromReader);
      msg.setCategoryLimits(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.accommodation.v1.CreateAccommodationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.accommodation.v1.CreateAccommodationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.accommodation.v1.CreateAccommodationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.CreateAccommodationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccommodation();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.accommodation.v1.Accommodation.serializeBinaryToWriter
    );
  }
  f = message.getCategoryLimits();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.witbooking.backoffice.accommodation.v1.CategoryLimitsInput.serializeBinaryToWriter
    );
  }
};


/**
 * optional Accommodation accommodation = 1;
 * @return {?proto.witbooking.backoffice.accommodation.v1.Accommodation}
 */
proto.witbooking.backoffice.accommodation.v1.CreateAccommodationRequest.prototype.getAccommodation = function() {
  return /** @type{?proto.witbooking.backoffice.accommodation.v1.Accommodation} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.accommodation.v1.Accommodation, 1));
};


/**
 * @param {?proto.witbooking.backoffice.accommodation.v1.Accommodation|undefined} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.CreateAccommodationRequest} returns this
*/
proto.witbooking.backoffice.accommodation.v1.CreateAccommodationRequest.prototype.setAccommodation = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.accommodation.v1.CreateAccommodationRequest} returns this
 */
proto.witbooking.backoffice.accommodation.v1.CreateAccommodationRequest.prototype.clearAccommodation = function() {
  return this.setAccommodation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.accommodation.v1.CreateAccommodationRequest.prototype.hasAccommodation = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional CategoryLimitsInput category_limits = 2;
 * @return {?proto.witbooking.backoffice.accommodation.v1.CategoryLimitsInput}
 */
proto.witbooking.backoffice.accommodation.v1.CreateAccommodationRequest.prototype.getCategoryLimits = function() {
  return /** @type{?proto.witbooking.backoffice.accommodation.v1.CategoryLimitsInput} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.accommodation.v1.CategoryLimitsInput, 2));
};


/**
 * @param {?proto.witbooking.backoffice.accommodation.v1.CategoryLimitsInput|undefined} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.CreateAccommodationRequest} returns this
*/
proto.witbooking.backoffice.accommodation.v1.CreateAccommodationRequest.prototype.setCategoryLimits = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.accommodation.v1.CreateAccommodationRequest} returns this
 */
proto.witbooking.backoffice.accommodation.v1.CreateAccommodationRequest.prototype.clearCategoryLimits = function() {
  return this.setCategoryLimits(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.accommodation.v1.CreateAccommodationRequest.prototype.hasCategoryLimits = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.accommodation.v1.CreateAccommodationResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.accommodation.v1.CreateAccommodationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.accommodation.v1.CreateAccommodationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.accommodation.v1.CreateAccommodationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.CreateAccommodationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    accommodation: (f = msg.getAccommodation()) && proto.witbooking.backoffice.accommodation.v1.Accommodation.toObject(includeInstance, f),
    warningsList: jspb.Message.toObjectList(msg.getWarningsList(),
    witbooking_backoffice_common_common_pb.ValidationIssue.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.accommodation.v1.CreateAccommodationResponse}
 */
proto.witbooking.backoffice.accommodation.v1.CreateAccommodationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.accommodation.v1.CreateAccommodationResponse;
  return proto.witbooking.backoffice.accommodation.v1.CreateAccommodationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.accommodation.v1.CreateAccommodationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.accommodation.v1.CreateAccommodationResponse}
 */
proto.witbooking.backoffice.accommodation.v1.CreateAccommodationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.accommodation.v1.Accommodation;
      reader.readMessage(value,proto.witbooking.backoffice.accommodation.v1.Accommodation.deserializeBinaryFromReader);
      msg.setAccommodation(value);
      break;
    case 2:
      var value = new witbooking_backoffice_common_common_pb.ValidationIssue;
      reader.readMessage(value,witbooking_backoffice_common_common_pb.ValidationIssue.deserializeBinaryFromReader);
      msg.addWarnings(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.accommodation.v1.CreateAccommodationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.accommodation.v1.CreateAccommodationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.accommodation.v1.CreateAccommodationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.CreateAccommodationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccommodation();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.accommodation.v1.Accommodation.serializeBinaryToWriter
    );
  }
  f = message.getWarningsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      witbooking_backoffice_common_common_pb.ValidationIssue.serializeBinaryToWriter
    );
  }
};


/**
 * optional Accommodation accommodation = 1;
 * @return {?proto.witbooking.backoffice.accommodation.v1.Accommodation}
 */
proto.witbooking.backoffice.accommodation.v1.CreateAccommodationResponse.prototype.getAccommodation = function() {
  return /** @type{?proto.witbooking.backoffice.accommodation.v1.Accommodation} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.accommodation.v1.Accommodation, 1));
};


/**
 * @param {?proto.witbooking.backoffice.accommodation.v1.Accommodation|undefined} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.CreateAccommodationResponse} returns this
*/
proto.witbooking.backoffice.accommodation.v1.CreateAccommodationResponse.prototype.setAccommodation = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.accommodation.v1.CreateAccommodationResponse} returns this
 */
proto.witbooking.backoffice.accommodation.v1.CreateAccommodationResponse.prototype.clearAccommodation = function() {
  return this.setAccommodation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.accommodation.v1.CreateAccommodationResponse.prototype.hasAccommodation = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated witbooking.backoffice.common.ValidationIssue warnings = 2;
 * @return {!Array<!proto.witbooking.backoffice.common.ValidationIssue>}
 */
proto.witbooking.backoffice.accommodation.v1.CreateAccommodationResponse.prototype.getWarningsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.common.ValidationIssue>} */ (
    jspb.Message.getRepeatedWrapperField(this, witbooking_backoffice_common_common_pb.ValidationIssue, 2));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.common.ValidationIssue>} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.CreateAccommodationResponse} returns this
*/
proto.witbooking.backoffice.accommodation.v1.CreateAccommodationResponse.prototype.setWarningsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.witbooking.backoffice.common.ValidationIssue=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.common.ValidationIssue}
 */
proto.witbooking.backoffice.accommodation.v1.CreateAccommodationResponse.prototype.addWarnings = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.witbooking.backoffice.common.ValidationIssue, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.accommodation.v1.CreateAccommodationResponse} returns this
 */
proto.witbooking.backoffice.accommodation.v1.CreateAccommodationResponse.prototype.clearWarningsList = function() {
  return this.setWarningsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    accommodation: (f = msg.getAccommodation()) && proto.witbooking.backoffice.accommodation.v1.Accommodation.toObject(includeInstance, f),
    categoryLimits: (f = msg.getCategoryLimits()) && proto.witbooking.backoffice.accommodation.v1.CategoryLimitsInput.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationRequest}
 */
proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationRequest;
  return proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationRequest}
 */
proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.accommodation.v1.Accommodation;
      reader.readMessage(value,proto.witbooking.backoffice.accommodation.v1.Accommodation.deserializeBinaryFromReader);
      msg.setAccommodation(value);
      break;
    case 2:
      var value = new proto.witbooking.backoffice.accommodation.v1.CategoryLimitsInput;
      reader.readMessage(value,proto.witbooking.backoffice.accommodation.v1.CategoryLimitsInput.deserializeBinaryFromReader);
      msg.setCategoryLimits(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccommodation();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.accommodation.v1.Accommodation.serializeBinaryToWriter
    );
  }
  f = message.getCategoryLimits();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.witbooking.backoffice.accommodation.v1.CategoryLimitsInput.serializeBinaryToWriter
    );
  }
};


/**
 * optional Accommodation accommodation = 1;
 * @return {?proto.witbooking.backoffice.accommodation.v1.Accommodation}
 */
proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationRequest.prototype.getAccommodation = function() {
  return /** @type{?proto.witbooking.backoffice.accommodation.v1.Accommodation} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.accommodation.v1.Accommodation, 1));
};


/**
 * @param {?proto.witbooking.backoffice.accommodation.v1.Accommodation|undefined} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationRequest} returns this
*/
proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationRequest.prototype.setAccommodation = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationRequest} returns this
 */
proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationRequest.prototype.clearAccommodation = function() {
  return this.setAccommodation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationRequest.prototype.hasAccommodation = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional CategoryLimitsInput category_limits = 2;
 * @return {?proto.witbooking.backoffice.accommodation.v1.CategoryLimitsInput}
 */
proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationRequest.prototype.getCategoryLimits = function() {
  return /** @type{?proto.witbooking.backoffice.accommodation.v1.CategoryLimitsInput} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.accommodation.v1.CategoryLimitsInput, 2));
};


/**
 * @param {?proto.witbooking.backoffice.accommodation.v1.CategoryLimitsInput|undefined} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationRequest} returns this
*/
proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationRequest.prototype.setCategoryLimits = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationRequest} returns this
 */
proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationRequest.prototype.clearCategoryLimits = function() {
  return this.setCategoryLimits(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationRequest.prototype.hasCategoryLimits = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    accommodation: (f = msg.getAccommodation()) && proto.witbooking.backoffice.accommodation.v1.Accommodation.toObject(includeInstance, f),
    warningsList: jspb.Message.toObjectList(msg.getWarningsList(),
    witbooking_backoffice_common_common_pb.ValidationIssue.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationResponse}
 */
proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationResponse;
  return proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationResponse}
 */
proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.accommodation.v1.Accommodation;
      reader.readMessage(value,proto.witbooking.backoffice.accommodation.v1.Accommodation.deserializeBinaryFromReader);
      msg.setAccommodation(value);
      break;
    case 2:
      var value = new witbooking_backoffice_common_common_pb.ValidationIssue;
      reader.readMessage(value,witbooking_backoffice_common_common_pb.ValidationIssue.deserializeBinaryFromReader);
      msg.addWarnings(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccommodation();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.accommodation.v1.Accommodation.serializeBinaryToWriter
    );
  }
  f = message.getWarningsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      witbooking_backoffice_common_common_pb.ValidationIssue.serializeBinaryToWriter
    );
  }
};


/**
 * optional Accommodation accommodation = 1;
 * @return {?proto.witbooking.backoffice.accommodation.v1.Accommodation}
 */
proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationResponse.prototype.getAccommodation = function() {
  return /** @type{?proto.witbooking.backoffice.accommodation.v1.Accommodation} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.accommodation.v1.Accommodation, 1));
};


/**
 * @param {?proto.witbooking.backoffice.accommodation.v1.Accommodation|undefined} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationResponse} returns this
*/
proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationResponse.prototype.setAccommodation = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationResponse} returns this
 */
proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationResponse.prototype.clearAccommodation = function() {
  return this.setAccommodation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationResponse.prototype.hasAccommodation = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated witbooking.backoffice.common.ValidationIssue warnings = 2;
 * @return {!Array<!proto.witbooking.backoffice.common.ValidationIssue>}
 */
proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationResponse.prototype.getWarningsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.common.ValidationIssue>} */ (
    jspb.Message.getRepeatedWrapperField(this, witbooking_backoffice_common_common_pb.ValidationIssue, 2));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.common.ValidationIssue>} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationResponse} returns this
*/
proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationResponse.prototype.setWarningsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.witbooking.backoffice.common.ValidationIssue=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.common.ValidationIssue}
 */
proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationResponse.prototype.addWarnings = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.witbooking.backoffice.common.ValidationIssue, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationResponse} returns this
 */
proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationResponse.prototype.clearWarningsList = function() {
  return this.setWarningsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    accommodationId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationRequest}
 */
proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationRequest;
  return proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationRequest}
 */
proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccommodationId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccommodationId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string accommodation_id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationRequest.prototype.getAccommodationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationRequest} returns this
 */
proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationRequest.prototype.setAccommodationId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationResponse}
 */
proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationResponse;
  return proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationResponse}
 */
proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    accommodationId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    afterId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationRequest}
 */
proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationRequest;
  return proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationRequest}
 */
proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccommodationId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAfterId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccommodationId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAfterId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string accommodation_id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationRequest.prototype.getAccommodationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationRequest} returns this
 */
proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationRequest.prototype.setAccommodationId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string after_id = 2;
 * @return {string}
 */
proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationRequest.prototype.getAfterId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationRequest} returns this
 */
proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationRequest.prototype.setAfterId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationResponse}
 */
proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationResponse;
  return proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationResponse}
 */
proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.accommodation.v1.GetAccommodationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.accommodation.v1.GetAccommodationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    accommodationId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.accommodation.v1.GetAccommodationRequest}
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.accommodation.v1.GetAccommodationRequest;
  return proto.witbooking.backoffice.accommodation.v1.GetAccommodationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.accommodation.v1.GetAccommodationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.accommodation.v1.GetAccommodationRequest}
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccommodationId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.accommodation.v1.GetAccommodationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.accommodation.v1.GetAccommodationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccommodationId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string accommodation_id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationRequest.prototype.getAccommodationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.GetAccommodationRequest} returns this
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationRequest.prototype.setAccommodationId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.accommodation.v1.GetAccommodationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.accommodation.v1.GetAccommodationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    accommodation: (f = msg.getAccommodation()) && proto.witbooking.backoffice.accommodation.v1.Accommodation.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.accommodation.v1.GetAccommodationResponse}
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.accommodation.v1.GetAccommodationResponse;
  return proto.witbooking.backoffice.accommodation.v1.GetAccommodationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.accommodation.v1.GetAccommodationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.accommodation.v1.GetAccommodationResponse}
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.accommodation.v1.Accommodation;
      reader.readMessage(value,proto.witbooking.backoffice.accommodation.v1.Accommodation.deserializeBinaryFromReader);
      msg.setAccommodation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.accommodation.v1.GetAccommodationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.accommodation.v1.GetAccommodationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccommodation();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.accommodation.v1.Accommodation.serializeBinaryToWriter
    );
  }
};


/**
 * optional Accommodation accommodation = 1;
 * @return {?proto.witbooking.backoffice.accommodation.v1.Accommodation}
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationResponse.prototype.getAccommodation = function() {
  return /** @type{?proto.witbooking.backoffice.accommodation.v1.Accommodation} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.accommodation.v1.Accommodation, 1));
};


/**
 * @param {?proto.witbooking.backoffice.accommodation.v1.Accommodation|undefined} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.GetAccommodationResponse} returns this
*/
proto.witbooking.backoffice.accommodation.v1.GetAccommodationResponse.prototype.setAccommodation = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.accommodation.v1.GetAccommodationResponse} returns this
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationResponse.prototype.clearAccommodation = function() {
  return this.setAccommodation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationResponse.prototype.hasAccommodation = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.accommodation.v1.GetAccommodationsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.accommodation.v1.GetAccommodationsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.accommodation.v1.GetAccommodationsRequest}
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.accommodation.v1.GetAccommodationsRequest;
  return proto.witbooking.backoffice.accommodation.v1.GetAccommodationsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.accommodation.v1.GetAccommodationsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.accommodation.v1.GetAccommodationsRequest}
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.accommodation.v1.GetAccommodationsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.accommodation.v1.GetAccommodationsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.accommodation.v1.GetAccommodationsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.accommodation.v1.GetAccommodationsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    accommodationList: jspb.Message.toObjectList(msg.getAccommodationList(),
    proto.witbooking.backoffice.accommodation.v1.Accommodation.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.accommodation.v1.GetAccommodationsResponse}
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.accommodation.v1.GetAccommodationsResponse;
  return proto.witbooking.backoffice.accommodation.v1.GetAccommodationsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.accommodation.v1.GetAccommodationsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.accommodation.v1.GetAccommodationsResponse}
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.accommodation.v1.Accommodation;
      reader.readMessage(value,proto.witbooking.backoffice.accommodation.v1.Accommodation.deserializeBinaryFromReader);
      msg.addAccommodation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.accommodation.v1.GetAccommodationsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.accommodation.v1.GetAccommodationsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccommodationList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.backoffice.accommodation.v1.Accommodation.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Accommodation accommodation = 1;
 * @return {!Array<!proto.witbooking.backoffice.accommodation.v1.Accommodation>}
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationsResponse.prototype.getAccommodationList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.accommodation.v1.Accommodation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.accommodation.v1.Accommodation, 1));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.accommodation.v1.Accommodation>} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.GetAccommodationsResponse} returns this
*/
proto.witbooking.backoffice.accommodation.v1.GetAccommodationsResponse.prototype.setAccommodationList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.backoffice.accommodation.v1.Accommodation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.accommodation.v1.Accommodation}
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationsResponse.prototype.addAccommodation = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.backoffice.accommodation.v1.Accommodation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.accommodation.v1.GetAccommodationsResponse} returns this
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationsResponse.prototype.clearAccommodationList = function() {
  return this.setAccommodationList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.accommodation.v1.Translation.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.accommodation.v1.Translation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.accommodation.v1.Translation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.Translation.toObject = function(includeInstance, msg) {
  var f, obj = {
    locale: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    description: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.accommodation.v1.Translation}
 */
proto.witbooking.backoffice.accommodation.v1.Translation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.accommodation.v1.Translation;
  return proto.witbooking.backoffice.accommodation.v1.Translation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.accommodation.v1.Translation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.accommodation.v1.Translation}
 */
proto.witbooking.backoffice.accommodation.v1.Translation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocale(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.accommodation.v1.Translation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.accommodation.v1.Translation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.accommodation.v1.Translation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.Translation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLocale();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string locale = 1;
 * @return {string}
 */
proto.witbooking.backoffice.accommodation.v1.Translation.prototype.getLocale = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.Translation} returns this
 */
proto.witbooking.backoffice.accommodation.v1.Translation.prototype.setLocale = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.witbooking.backoffice.accommodation.v1.Translation.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.Translation} returns this
 */
proto.witbooking.backoffice.accommodation.v1.Translation.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.witbooking.backoffice.accommodation.v1.Translation.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.Translation} returns this
 */
proto.witbooking.backoffice.accommodation.v1.Translation.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.accommodation.v1.MultimediaTranslation.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.accommodation.v1.MultimediaTranslation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.accommodation.v1.MultimediaTranslation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.MultimediaTranslation.toObject = function(includeInstance, msg) {
  var f, obj = {
    locale: jspb.Message.getFieldWithDefault(msg, 1, ""),
    title: jspb.Message.getFieldWithDefault(msg, 2, ""),
    description: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.accommodation.v1.MultimediaTranslation}
 */
proto.witbooking.backoffice.accommodation.v1.MultimediaTranslation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.accommodation.v1.MultimediaTranslation;
  return proto.witbooking.backoffice.accommodation.v1.MultimediaTranslation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.accommodation.v1.MultimediaTranslation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.accommodation.v1.MultimediaTranslation}
 */
proto.witbooking.backoffice.accommodation.v1.MultimediaTranslation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocale(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.accommodation.v1.MultimediaTranslation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.accommodation.v1.MultimediaTranslation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.accommodation.v1.MultimediaTranslation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.MultimediaTranslation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLocale();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string locale = 1;
 * @return {string}
 */
proto.witbooking.backoffice.accommodation.v1.MultimediaTranslation.prototype.getLocale = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.MultimediaTranslation} returns this
 */
proto.witbooking.backoffice.accommodation.v1.MultimediaTranslation.prototype.setLocale = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.witbooking.backoffice.accommodation.v1.MultimediaTranslation.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.MultimediaTranslation} returns this
 */
proto.witbooking.backoffice.accommodation.v1.MultimediaTranslation.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.witbooking.backoffice.accommodation.v1.MultimediaTranslation.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.MultimediaTranslation} returns this
 */
proto.witbooking.backoffice.accommodation.v1.MultimediaTranslation.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.accommodation.v1.Multimedia.repeatedFields_ = [4,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.accommodation.v1.Multimedia.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.accommodation.v1.Multimedia.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.accommodation.v1.Multimedia} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.Multimedia.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    filename: jspb.Message.getFieldWithDefault(msg, 2, ""),
    url: jspb.Message.getFieldWithDefault(msg, 3, ""),
    translationsList: jspb.Message.toObjectList(msg.getTranslationsList(),
    proto.witbooking.backoffice.accommodation.v1.MultimediaTranslation.toObject, includeInstance),
    labelsList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
    caption: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.accommodation.v1.Multimedia}
 */
proto.witbooking.backoffice.accommodation.v1.Multimedia.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.accommodation.v1.Multimedia;
  return proto.witbooking.backoffice.accommodation.v1.Multimedia.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.accommodation.v1.Multimedia} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.accommodation.v1.Multimedia}
 */
proto.witbooking.backoffice.accommodation.v1.Multimedia.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilename(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 4:
      var value = new proto.witbooking.backoffice.accommodation.v1.MultimediaTranslation;
      reader.readMessage(value,proto.witbooking.backoffice.accommodation.v1.MultimediaTranslation.deserializeBinaryFromReader);
      msg.addTranslations(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addLabels(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCaption(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.accommodation.v1.Multimedia.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.accommodation.v1.Multimedia.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.accommodation.v1.Multimedia} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.Multimedia.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFilename();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTranslationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.witbooking.backoffice.accommodation.v1.MultimediaTranslation.serializeBinaryToWriter
    );
  }
  f = message.getLabelsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
  f = message.getCaption();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.accommodation.v1.Multimedia.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.Multimedia} returns this
 */
proto.witbooking.backoffice.accommodation.v1.Multimedia.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string filename = 2;
 * @return {string}
 */
proto.witbooking.backoffice.accommodation.v1.Multimedia.prototype.getFilename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.Multimedia} returns this
 */
proto.witbooking.backoffice.accommodation.v1.Multimedia.prototype.setFilename = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string url = 3;
 * @return {string}
 */
proto.witbooking.backoffice.accommodation.v1.Multimedia.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.Multimedia} returns this
 */
proto.witbooking.backoffice.accommodation.v1.Multimedia.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated MultimediaTranslation translations = 4;
 * @return {!Array<!proto.witbooking.backoffice.accommodation.v1.MultimediaTranslation>}
 */
proto.witbooking.backoffice.accommodation.v1.Multimedia.prototype.getTranslationsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.accommodation.v1.MultimediaTranslation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.accommodation.v1.MultimediaTranslation, 4));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.accommodation.v1.MultimediaTranslation>} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.Multimedia} returns this
*/
proto.witbooking.backoffice.accommodation.v1.Multimedia.prototype.setTranslationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.witbooking.backoffice.accommodation.v1.MultimediaTranslation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.accommodation.v1.MultimediaTranslation}
 */
proto.witbooking.backoffice.accommodation.v1.Multimedia.prototype.addTranslations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.witbooking.backoffice.accommodation.v1.MultimediaTranslation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.accommodation.v1.Multimedia} returns this
 */
proto.witbooking.backoffice.accommodation.v1.Multimedia.prototype.clearTranslationsList = function() {
  return this.setTranslationsList([]);
};


/**
 * repeated string labels = 5;
 * @return {!Array<string>}
 */
proto.witbooking.backoffice.accommodation.v1.Multimedia.prototype.getLabelsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.Multimedia} returns this
 */
proto.witbooking.backoffice.accommodation.v1.Multimedia.prototype.setLabelsList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.accommodation.v1.Multimedia} returns this
 */
proto.witbooking.backoffice.accommodation.v1.Multimedia.prototype.addLabels = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.accommodation.v1.Multimedia} returns this
 */
proto.witbooking.backoffice.accommodation.v1.Multimedia.prototype.clearLabelsList = function() {
  return this.setLabelsList([]);
};


/**
 * optional string caption = 7;
 * @return {string}
 */
proto.witbooking.backoffice.accommodation.v1.Multimedia.prototype.getCaption = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.Multimedia} returns this
 */
proto.witbooking.backoffice.accommodation.v1.Multimedia.prototype.setCaption = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.accommodation.v1.Accommodation.repeatedFields_ = [3,5,8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.accommodation.v1.Accommodation.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.accommodation.v1.Accommodation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.accommodation.v1.Accommodation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.Accommodation.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    ticker: jspb.Message.getFieldWithDefault(msg, 2, ""),
    translationsList: jspb.Message.toObjectList(msg.getTranslationsList(),
    proto.witbooking.backoffice.accommodation.v1.Translation.toObject, includeInstance),
    type: jspb.Message.getFieldWithDefault(msg, 4, 0),
    multimediaList: jspb.Message.toObjectList(msg.getMultimediaList(),
    proto.witbooking.backoffice.accommodation.v1.Multimedia.toObject, includeInstance),
    active: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    occupancy: (f = msg.getOccupancy()) && proto.witbooking.backoffice.accommodation.v1.AccommodationOccupancy.toObject(includeInstance, f),
    occupancyCombinationsList: (f = jspb.Message.getRepeatedField(msg, 8)) == null ? undefined : f,
    accommodationBaseAdults: jspb.Message.getFieldWithDefault(msg, 9, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.accommodation.v1.Accommodation}
 */
proto.witbooking.backoffice.accommodation.v1.Accommodation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.accommodation.v1.Accommodation;
  return proto.witbooking.backoffice.accommodation.v1.Accommodation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.accommodation.v1.Accommodation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.accommodation.v1.Accommodation}
 */
proto.witbooking.backoffice.accommodation.v1.Accommodation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    case 3:
      var value = new proto.witbooking.backoffice.accommodation.v1.Translation;
      reader.readMessage(value,proto.witbooking.backoffice.accommodation.v1.Translation.deserializeBinaryFromReader);
      msg.addTranslations(value);
      break;
    case 4:
      var value = /** @type {!proto.witbooking.backoffice.common.RoomDenominationType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 5:
      var value = new proto.witbooking.backoffice.accommodation.v1.Multimedia;
      reader.readMessage(value,proto.witbooking.backoffice.accommodation.v1.Multimedia.deserializeBinaryFromReader);
      msg.addMultimedia(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActive(value);
      break;
    case 7:
      var value = new proto.witbooking.backoffice.accommodation.v1.AccommodationOccupancy;
      reader.readMessage(value,proto.witbooking.backoffice.accommodation.v1.AccommodationOccupancy.deserializeBinaryFromReader);
      msg.setOccupancy(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.addOccupancyCombinations(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAccommodationBaseAdults(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.accommodation.v1.Accommodation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.accommodation.v1.Accommodation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.accommodation.v1.Accommodation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.Accommodation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTranslationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.witbooking.backoffice.accommodation.v1.Translation.serializeBinaryToWriter
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getMultimediaList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.witbooking.backoffice.accommodation.v1.Multimedia.serializeBinaryToWriter
    );
  }
  f = message.getActive();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getOccupancy();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.witbooking.backoffice.accommodation.v1.AccommodationOccupancy.serializeBinaryToWriter
    );
  }
  f = message.getOccupancyCombinationsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      8,
      f
    );
  }
  f = message.getAccommodationBaseAdults();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.accommodation.v1.Accommodation.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.Accommodation} returns this
 */
proto.witbooking.backoffice.accommodation.v1.Accommodation.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ticker = 2;
 * @return {string}
 */
proto.witbooking.backoffice.accommodation.v1.Accommodation.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.Accommodation} returns this
 */
proto.witbooking.backoffice.accommodation.v1.Accommodation.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated Translation translations = 3;
 * @return {!Array<!proto.witbooking.backoffice.accommodation.v1.Translation>}
 */
proto.witbooking.backoffice.accommodation.v1.Accommodation.prototype.getTranslationsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.accommodation.v1.Translation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.accommodation.v1.Translation, 3));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.accommodation.v1.Translation>} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.Accommodation} returns this
*/
proto.witbooking.backoffice.accommodation.v1.Accommodation.prototype.setTranslationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.witbooking.backoffice.accommodation.v1.Translation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.accommodation.v1.Translation}
 */
proto.witbooking.backoffice.accommodation.v1.Accommodation.prototype.addTranslations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.witbooking.backoffice.accommodation.v1.Translation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.accommodation.v1.Accommodation} returns this
 */
proto.witbooking.backoffice.accommodation.v1.Accommodation.prototype.clearTranslationsList = function() {
  return this.setTranslationsList([]);
};


/**
 * optional witbooking.backoffice.common.RoomDenominationType type = 4;
 * @return {!proto.witbooking.backoffice.common.RoomDenominationType}
 */
proto.witbooking.backoffice.accommodation.v1.Accommodation.prototype.getType = function() {
  return /** @type {!proto.witbooking.backoffice.common.RoomDenominationType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.witbooking.backoffice.common.RoomDenominationType} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.Accommodation} returns this
 */
proto.witbooking.backoffice.accommodation.v1.Accommodation.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * repeated Multimedia multimedia = 5;
 * @return {!Array<!proto.witbooking.backoffice.accommodation.v1.Multimedia>}
 */
proto.witbooking.backoffice.accommodation.v1.Accommodation.prototype.getMultimediaList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.accommodation.v1.Multimedia>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.accommodation.v1.Multimedia, 5));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.accommodation.v1.Multimedia>} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.Accommodation} returns this
*/
proto.witbooking.backoffice.accommodation.v1.Accommodation.prototype.setMultimediaList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.witbooking.backoffice.accommodation.v1.Multimedia=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.accommodation.v1.Multimedia}
 */
proto.witbooking.backoffice.accommodation.v1.Accommodation.prototype.addMultimedia = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.witbooking.backoffice.accommodation.v1.Multimedia, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.accommodation.v1.Accommodation} returns this
 */
proto.witbooking.backoffice.accommodation.v1.Accommodation.prototype.clearMultimediaList = function() {
  return this.setMultimediaList([]);
};


/**
 * optional bool active = 6;
 * @return {boolean}
 */
proto.witbooking.backoffice.accommodation.v1.Accommodation.prototype.getActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.Accommodation} returns this
 */
proto.witbooking.backoffice.accommodation.v1.Accommodation.prototype.setActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional AccommodationOccupancy occupancy = 7;
 * @return {?proto.witbooking.backoffice.accommodation.v1.AccommodationOccupancy}
 */
proto.witbooking.backoffice.accommodation.v1.Accommodation.prototype.getOccupancy = function() {
  return /** @type{?proto.witbooking.backoffice.accommodation.v1.AccommodationOccupancy} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.accommodation.v1.AccommodationOccupancy, 7));
};


/**
 * @param {?proto.witbooking.backoffice.accommodation.v1.AccommodationOccupancy|undefined} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.Accommodation} returns this
*/
proto.witbooking.backoffice.accommodation.v1.Accommodation.prototype.setOccupancy = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.accommodation.v1.Accommodation} returns this
 */
proto.witbooking.backoffice.accommodation.v1.Accommodation.prototype.clearOccupancy = function() {
  return this.setOccupancy(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.accommodation.v1.Accommodation.prototype.hasOccupancy = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * repeated string occupancy_combinations = 8;
 * @return {!Array<string>}
 */
proto.witbooking.backoffice.accommodation.v1.Accommodation.prototype.getOccupancyCombinationsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 8));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.Accommodation} returns this
 */
proto.witbooking.backoffice.accommodation.v1.Accommodation.prototype.setOccupancyCombinationsList = function(value) {
  return jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.accommodation.v1.Accommodation} returns this
 */
proto.witbooking.backoffice.accommodation.v1.Accommodation.prototype.addOccupancyCombinations = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.accommodation.v1.Accommodation} returns this
 */
proto.witbooking.backoffice.accommodation.v1.Accommodation.prototype.clearOccupancyCombinationsList = function() {
  return this.setOccupancyCombinationsList([]);
};


/**
 * optional int32 accommodation_base_adults = 9;
 * @return {number}
 */
proto.witbooking.backoffice.accommodation.v1.Accommodation.prototype.getAccommodationBaseAdults = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.Accommodation} returns this
 */
proto.witbooking.backoffice.accommodation.v1.Accommodation.prototype.setAccommodationBaseAdults = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.accommodation.v1.MaxOccupancyByType.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.accommodation.v1.MaxOccupancyByType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.accommodation.v1.MaxOccupancyByType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.MaxOccupancyByType.toObject = function(includeInstance, msg) {
  var f, obj = {
    senior: jspb.Message.getFieldWithDefault(msg, 1, 0),
    adults: jspb.Message.getFieldWithDefault(msg, 2, 0),
    juniors: jspb.Message.getFieldWithDefault(msg, 3, 0),
    children: jspb.Message.getFieldWithDefault(msg, 4, 0),
    babies: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.accommodation.v1.MaxOccupancyByType}
 */
proto.witbooking.backoffice.accommodation.v1.MaxOccupancyByType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.accommodation.v1.MaxOccupancyByType;
  return proto.witbooking.backoffice.accommodation.v1.MaxOccupancyByType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.accommodation.v1.MaxOccupancyByType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.accommodation.v1.MaxOccupancyByType}
 */
proto.witbooking.backoffice.accommodation.v1.MaxOccupancyByType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSenior(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAdults(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setJuniors(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setChildren(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBabies(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.accommodation.v1.MaxOccupancyByType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.accommodation.v1.MaxOccupancyByType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.accommodation.v1.MaxOccupancyByType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.MaxOccupancyByType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSenior();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getAdults();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getJuniors();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getChildren();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getBabies();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional int32 senior = 1;
 * @return {number}
 */
proto.witbooking.backoffice.accommodation.v1.MaxOccupancyByType.prototype.getSenior = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.MaxOccupancyByType} returns this
 */
proto.witbooking.backoffice.accommodation.v1.MaxOccupancyByType.prototype.setSenior = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 adults = 2;
 * @return {number}
 */
proto.witbooking.backoffice.accommodation.v1.MaxOccupancyByType.prototype.getAdults = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.MaxOccupancyByType} returns this
 */
proto.witbooking.backoffice.accommodation.v1.MaxOccupancyByType.prototype.setAdults = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 juniors = 3;
 * @return {number}
 */
proto.witbooking.backoffice.accommodation.v1.MaxOccupancyByType.prototype.getJuniors = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.MaxOccupancyByType} returns this
 */
proto.witbooking.backoffice.accommodation.v1.MaxOccupancyByType.prototype.setJuniors = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 children = 4;
 * @return {number}
 */
proto.witbooking.backoffice.accommodation.v1.MaxOccupancyByType.prototype.getChildren = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.MaxOccupancyByType} returns this
 */
proto.witbooking.backoffice.accommodation.v1.MaxOccupancyByType.prototype.setChildren = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 babies = 5;
 * @return {number}
 */
proto.witbooking.backoffice.accommodation.v1.MaxOccupancyByType.prototype.getBabies = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.MaxOccupancyByType} returns this
 */
proto.witbooking.backoffice.accommodation.v1.MaxOccupancyByType.prototype.setBabies = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.accommodation.v1.AccommodationOccupancy.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.accommodation.v1.AccommodationOccupancy.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.accommodation.v1.AccommodationOccupancy} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.AccommodationOccupancy.toObject = function(includeInstance, msg) {
  var f, obj = {
    maxOccupancy: jspb.Message.getFieldWithDefault(msg, 1, 0),
    maxOccupancyByType: (f = msg.getMaxOccupancyByType()) && proto.witbooking.backoffice.accommodation.v1.MaxOccupancyByType.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.accommodation.v1.AccommodationOccupancy}
 */
proto.witbooking.backoffice.accommodation.v1.AccommodationOccupancy.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.accommodation.v1.AccommodationOccupancy;
  return proto.witbooking.backoffice.accommodation.v1.AccommodationOccupancy.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.accommodation.v1.AccommodationOccupancy} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.accommodation.v1.AccommodationOccupancy}
 */
proto.witbooking.backoffice.accommodation.v1.AccommodationOccupancy.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxOccupancy(value);
      break;
    case 2:
      var value = new proto.witbooking.backoffice.accommodation.v1.MaxOccupancyByType;
      reader.readMessage(value,proto.witbooking.backoffice.accommodation.v1.MaxOccupancyByType.deserializeBinaryFromReader);
      msg.setMaxOccupancyByType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.accommodation.v1.AccommodationOccupancy.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.accommodation.v1.AccommodationOccupancy.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.accommodation.v1.AccommodationOccupancy} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.AccommodationOccupancy.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMaxOccupancy();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getMaxOccupancyByType();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.witbooking.backoffice.accommodation.v1.MaxOccupancyByType.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 max_occupancy = 1;
 * @return {number}
 */
proto.witbooking.backoffice.accommodation.v1.AccommodationOccupancy.prototype.getMaxOccupancy = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.AccommodationOccupancy} returns this
 */
proto.witbooking.backoffice.accommodation.v1.AccommodationOccupancy.prototype.setMaxOccupancy = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional MaxOccupancyByType max_occupancy_by_type = 2;
 * @return {?proto.witbooking.backoffice.accommodation.v1.MaxOccupancyByType}
 */
proto.witbooking.backoffice.accommodation.v1.AccommodationOccupancy.prototype.getMaxOccupancyByType = function() {
  return /** @type{?proto.witbooking.backoffice.accommodation.v1.MaxOccupancyByType} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.accommodation.v1.MaxOccupancyByType, 2));
};


/**
 * @param {?proto.witbooking.backoffice.accommodation.v1.MaxOccupancyByType|undefined} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.AccommodationOccupancy} returns this
*/
proto.witbooking.backoffice.accommodation.v1.AccommodationOccupancy.prototype.setMaxOccupancyByType = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.accommodation.v1.AccommodationOccupancy} returns this
 */
proto.witbooking.backoffice.accommodation.v1.AccommodationOccupancy.prototype.clearMaxOccupancyByType = function() {
  return this.setMaxOccupancyByType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.accommodation.v1.AccommodationOccupancy.prototype.hasMaxOccupancyByType = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsInput.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsInput.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.accommodation.v1.CategoryLimitsInput.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsInput} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsInput.toObject = function(includeInstance, msg) {
  var f, obj = {
    blocksList: jspb.Message.toObjectList(msg.getBlocksList(),
    proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsInput}
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsInput.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.accommodation.v1.CategoryLimitsInput;
  return proto.witbooking.backoffice.accommodation.v1.CategoryLimitsInput.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsInput} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsInput}
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsInput.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput;
      reader.readMessage(value,proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput.deserializeBinaryFromReader);
      msg.addBlocks(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsInput.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.accommodation.v1.CategoryLimitsInput.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsInput} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsInput.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBlocksList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput.serializeBinaryToWriter
    );
  }
};


/**
 * repeated CategoryLimitsBlockInput blocks = 1;
 * @return {!Array<!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput>}
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsInput.prototype.getBlocksList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput, 1));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput>} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsInput} returns this
*/
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsInput.prototype.setBlocksList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput}
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsInput.prototype.addBlocks = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsInput} returns this
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsInput.prototype.clearBlocksList = function() {
  return this.setBlocksList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput.toObject = function(includeInstance, msg) {
  var f, obj = {
    category: jspb.Message.getFieldWithDefault(msg, 1, 0),
    enabled: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    included: (f = msg.getIncluded()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    max: (f = msg.getMax()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    tickedExtraTickersList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput}
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput;
  return proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput}
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.witbooking.backoffice.common.ExtraCategory} */ (reader.readEnum());
      msg.setCategory(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setIncluded(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setMax(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addTickedExtraTickers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCategory();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getEnabled();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getIncluded();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getMax();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getTickedExtraTickersList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
};


/**
 * optional witbooking.backoffice.common.ExtraCategory category = 1;
 * @return {!proto.witbooking.backoffice.common.ExtraCategory}
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput.prototype.getCategory = function() {
  return /** @type {!proto.witbooking.backoffice.common.ExtraCategory} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.witbooking.backoffice.common.ExtraCategory} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput} returns this
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput.prototype.setCategory = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional bool enabled = 2;
 * @return {boolean}
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput} returns this
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput.prototype.setEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional google.protobuf.Int32Value included = 3;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput.prototype.getIncluded = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 3));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput} returns this
*/
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput.prototype.setIncluded = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput} returns this
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput.prototype.clearIncluded = function() {
  return this.setIncluded(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput.prototype.hasIncluded = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Int32Value max = 4;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput.prototype.getMax = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 4));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput} returns this
*/
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput.prototype.setMax = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput} returns this
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput.prototype.clearMax = function() {
  return this.setMax(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput.prototype.hasMax = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * repeated string ticked_extra_tickers = 5;
 * @return {!Array<string>}
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput.prototype.getTickedExtraTickersList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput} returns this
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput.prototype.setTickedExtraTickersList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput} returns this
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput.prototype.addTickedExtraTickers = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput} returns this
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockInput.prototype.clearTickedExtraTickersList = function() {
  return this.setTickedExtraTickersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    accommodationId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    locale: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsRequest}
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsRequest;
  return proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsRequest}
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccommodationId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocale(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccommodationId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLocale();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string accommodation_id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsRequest.prototype.getAccommodationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsRequest} returns this
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsRequest.prototype.setAccommodationId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string locale = 2;
 * @return {string}
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsRequest.prototype.getLocale = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsRequest} returns this
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsRequest.prototype.setLocale = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsResponse.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    featureActive: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    sectionVisible: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    blocksList: jspb.Message.toObjectList(msg.getBlocksList(),
    proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsResponse}
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsResponse;
  return proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsResponse}
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFeatureActive(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSectionVisible(value);
      break;
    case 3:
      var value = new proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView;
      reader.readMessage(value,proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView.deserializeBinaryFromReader);
      msg.addBlocks(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFeatureActive();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getSectionVisible();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getBlocksList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool feature_active = 1;
 * @return {boolean}
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsResponse.prototype.getFeatureActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsResponse} returns this
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsResponse.prototype.setFeatureActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool section_visible = 2;
 * @return {boolean}
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsResponse.prototype.getSectionVisible = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsResponse} returns this
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsResponse.prototype.setSectionVisible = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * repeated CategoryLimitsBlockView blocks = 3;
 * @return {!Array<!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView>}
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsResponse.prototype.getBlocksList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView, 3));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView>} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsResponse} returns this
*/
proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsResponse.prototype.setBlocksList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView}
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsResponse.prototype.addBlocks = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsResponse} returns this
 */
proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsResponse.prototype.clearBlocksList = function() {
  return this.setBlocksList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView.toObject = function(includeInstance, msg) {
  var f, obj = {
    category: jspb.Message.getFieldWithDefault(msg, 1, 0),
    enabled: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    included: (f = msg.getIncluded()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    max: (f = msg.getMax()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    extrasList: jspb.Message.toObjectList(msg.getExtrasList(),
    proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView}
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView;
  return proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView}
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.witbooking.backoffice.common.ExtraCategory} */ (reader.readEnum());
      msg.setCategory(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setIncluded(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setMax(value);
      break;
    case 5:
      var value = new proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine;
      reader.readMessage(value,proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine.deserializeBinaryFromReader);
      msg.addExtras(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCategory();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getEnabled();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getIncluded();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getMax();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getExtrasList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine.serializeBinaryToWriter
    );
  }
};


/**
 * optional witbooking.backoffice.common.ExtraCategory category = 1;
 * @return {!proto.witbooking.backoffice.common.ExtraCategory}
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView.prototype.getCategory = function() {
  return /** @type {!proto.witbooking.backoffice.common.ExtraCategory} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.witbooking.backoffice.common.ExtraCategory} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView} returns this
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView.prototype.setCategory = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional bool enabled = 2;
 * @return {boolean}
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView} returns this
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView.prototype.setEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional google.protobuf.Int32Value included = 3;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView.prototype.getIncluded = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 3));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView} returns this
*/
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView.prototype.setIncluded = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView} returns this
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView.prototype.clearIncluded = function() {
  return this.setIncluded(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView.prototype.hasIncluded = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Int32Value max = 4;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView.prototype.getMax = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 4));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView} returns this
*/
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView.prototype.setMax = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView} returns this
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView.prototype.clearMax = function() {
  return this.setMax(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView.prototype.hasMax = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * repeated CategoryLimitsExtraLine extras = 5;
 * @return {!Array<!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine>}
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView.prototype.getExtrasList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine, 5));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine>} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView} returns this
*/
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView.prototype.setExtrasList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine}
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView.prototype.addExtras = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView} returns this
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsBlockView.prototype.clearExtrasList = function() {
  return this.setExtrasList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine.toObject = function(includeInstance, msg) {
  var f, obj = {
    extraId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    ticker: jspb.Message.getFieldWithDefault(msg, 2, ""),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    unitType: jspb.Message.getFieldWithDefault(msg, 4, 0),
    price: (f = msg.getPrice()) && proto.witbooking.backoffice.accommodation.v1.CategoryExtraPrice.toObject(includeInstance, f),
    active: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    ticked: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    coversInventoryLine: jspb.Message.getBooleanFieldWithDefault(msg, 8, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine}
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine;
  return proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine}
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setExtraId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {!proto.witbooking.backoffice.accommodation.v1.CategoryExtraUnitType} */ (reader.readEnum());
      msg.setUnitType(value);
      break;
    case 5:
      var value = new proto.witbooking.backoffice.accommodation.v1.CategoryExtraPrice;
      reader.readMessage(value,proto.witbooking.backoffice.accommodation.v1.CategoryExtraPrice.deserializeBinaryFromReader);
      msg.setPrice(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActive(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTicked(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCoversInventoryLine(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExtraId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUnitType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getPrice();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.witbooking.backoffice.accommodation.v1.CategoryExtraPrice.serializeBinaryToWriter
    );
  }
  f = message.getActive();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getTicked();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getCoversInventoryLine();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
};


/**
 * optional string extra_id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine.prototype.getExtraId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine} returns this
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine.prototype.setExtraId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ticker = 2;
 * @return {string}
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine} returns this
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine} returns this
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional CategoryExtraUnitType unit_type = 4;
 * @return {!proto.witbooking.backoffice.accommodation.v1.CategoryExtraUnitType}
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine.prototype.getUnitType = function() {
  return /** @type {!proto.witbooking.backoffice.accommodation.v1.CategoryExtraUnitType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.witbooking.backoffice.accommodation.v1.CategoryExtraUnitType} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine} returns this
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine.prototype.setUnitType = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional CategoryExtraPrice price = 5;
 * @return {?proto.witbooking.backoffice.accommodation.v1.CategoryExtraPrice}
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine.prototype.getPrice = function() {
  return /** @type{?proto.witbooking.backoffice.accommodation.v1.CategoryExtraPrice} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.accommodation.v1.CategoryExtraPrice, 5));
};


/**
 * @param {?proto.witbooking.backoffice.accommodation.v1.CategoryExtraPrice|undefined} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine} returns this
*/
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine.prototype.setPrice = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine} returns this
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine.prototype.clearPrice = function() {
  return this.setPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine.prototype.hasPrice = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional bool active = 6;
 * @return {boolean}
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine.prototype.getActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine} returns this
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine.prototype.setActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional bool ticked = 7;
 * @return {boolean}
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine.prototype.getTicked = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine} returns this
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine.prototype.setTicked = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional bool covers_inventory_line = 8;
 * @return {boolean}
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine.prototype.getCoversInventoryLine = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine} returns this
 */
proto.witbooking.backoffice.accommodation.v1.CategoryLimitsExtraLine.prototype.setCoversInventoryLine = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.witbooking.backoffice.accommodation.v1.CategoryExtraPrice.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.witbooking.backoffice.accommodation.v1.CategoryExtraPrice.ValueCase = {
  VALUE_NOT_SET: 0,
  CONSTANT_AMOUNT: 1,
  RATE_TYPE: 2
};

/**
 * @return {proto.witbooking.backoffice.accommodation.v1.CategoryExtraPrice.ValueCase}
 */
proto.witbooking.backoffice.accommodation.v1.CategoryExtraPrice.prototype.getValueCase = function() {
  return /** @type {proto.witbooking.backoffice.accommodation.v1.CategoryExtraPrice.ValueCase} */(jspb.Message.computeOneofCase(this, proto.witbooking.backoffice.accommodation.v1.CategoryExtraPrice.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.accommodation.v1.CategoryExtraPrice.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.accommodation.v1.CategoryExtraPrice.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.accommodation.v1.CategoryExtraPrice} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.CategoryExtraPrice.toObject = function(includeInstance, msg) {
  var f, obj = {
    constantAmount: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    rateType: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.accommodation.v1.CategoryExtraPrice}
 */
proto.witbooking.backoffice.accommodation.v1.CategoryExtraPrice.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.accommodation.v1.CategoryExtraPrice;
  return proto.witbooking.backoffice.accommodation.v1.CategoryExtraPrice.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.accommodation.v1.CategoryExtraPrice} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.accommodation.v1.CategoryExtraPrice}
 */
proto.witbooking.backoffice.accommodation.v1.CategoryExtraPrice.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setConstantAmount(value);
      break;
    case 2:
      var value = /** @type {!proto.witbooking.backoffice.accommodation.v1.CategoryExtraRateType} */ (reader.readEnum());
      msg.setRateType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.accommodation.v1.CategoryExtraPrice.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.accommodation.v1.CategoryExtraPrice.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.accommodation.v1.CategoryExtraPrice} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.CategoryExtraPrice.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = /** @type {!proto.witbooking.backoffice.accommodation.v1.CategoryExtraRateType} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional double constant_amount = 1;
 * @return {number}
 */
proto.witbooking.backoffice.accommodation.v1.CategoryExtraPrice.prototype.getConstantAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.CategoryExtraPrice} returns this
 */
proto.witbooking.backoffice.accommodation.v1.CategoryExtraPrice.prototype.setConstantAmount = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.witbooking.backoffice.accommodation.v1.CategoryExtraPrice.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.witbooking.backoffice.accommodation.v1.CategoryExtraPrice} returns this
 */
proto.witbooking.backoffice.accommodation.v1.CategoryExtraPrice.prototype.clearConstantAmount = function() {
  return jspb.Message.setOneofField(this, 1, proto.witbooking.backoffice.accommodation.v1.CategoryExtraPrice.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.accommodation.v1.CategoryExtraPrice.prototype.hasConstantAmount = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional CategoryExtraRateType rate_type = 2;
 * @return {!proto.witbooking.backoffice.accommodation.v1.CategoryExtraRateType}
 */
proto.witbooking.backoffice.accommodation.v1.CategoryExtraPrice.prototype.getRateType = function() {
  return /** @type {!proto.witbooking.backoffice.accommodation.v1.CategoryExtraRateType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.witbooking.backoffice.accommodation.v1.CategoryExtraRateType} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.CategoryExtraPrice} returns this
 */
proto.witbooking.backoffice.accommodation.v1.CategoryExtraPrice.prototype.setRateType = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.witbooking.backoffice.accommodation.v1.CategoryExtraPrice.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.witbooking.backoffice.accommodation.v1.CategoryExtraPrice} returns this
 */
proto.witbooking.backoffice.accommodation.v1.CategoryExtraPrice.prototype.clearRateType = function() {
  return jspb.Message.setOneofField(this, 2, proto.witbooking.backoffice.accommodation.v1.CategoryExtraPrice.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.accommodation.v1.CategoryExtraPrice.prototype.hasRateType = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsRequest}
 */
proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsRequest;
  return proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsRequest}
 */
proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    byAccommodationIdMap: (f = msg.getByAccommodationIdMap()) ? f.toObject(includeInstance, proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimits.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsResponse}
 */
proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsResponse;
  return proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsResponse}
 */
proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getByAccommodationIdMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimits.deserializeBinaryFromReader, "", new proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimits());
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getByAccommodationIdMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimits.serializeBinaryToWriter);
  }
};


/**
 * map<string, EngineCategoryLimits> by_accommodation_id = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimits>}
 */
proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsResponse.prototype.getByAccommodationIdMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimits>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimits));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsResponse} returns this
 */
proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsResponse.prototype.clearByAccommodationIdMap = function() {
  this.getByAccommodationIdMap().clear();
  return this;};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimits.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimits.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimits.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimits} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimits.toObject = function(includeInstance, msg) {
  var f, obj = {
    limitsList: jspb.Message.toObjectList(msg.getLimitsList(),
    proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimit.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimits}
 */
proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimits.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimits;
  return proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimits.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimits} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimits}
 */
proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimits.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimit;
      reader.readMessage(value,proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimit.deserializeBinaryFromReader);
      msg.addLimits(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimits.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimits.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimits} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimits.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLimitsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimit.serializeBinaryToWriter
    );
  }
};


/**
 * repeated EngineCategoryLimit limits = 1;
 * @return {!Array<!proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimit>}
 */
proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimits.prototype.getLimitsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimit>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimit, 1));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimit>} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimits} returns this
*/
proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimits.prototype.setLimitsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimit=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimit}
 */
proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimits.prototype.addLimits = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimit, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimits} returns this
 */
proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimits.prototype.clearLimitsList = function() {
  return this.setLimitsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimit.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimit.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimit.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimit} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimit.toObject = function(includeInstance, msg) {
  var f, obj = {
    category: jspb.Message.getFieldWithDefault(msg, 1, 0),
    included: jspb.Message.getFieldWithDefault(msg, 2, 0),
    max: jspb.Message.getFieldWithDefault(msg, 3, 0),
    allowedExtraTickersList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimit}
 */
proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimit.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimit;
  return proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimit.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimit} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimit}
 */
proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimit.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.witbooking.backoffice.common.ExtraCategory} */ (reader.readEnum());
      msg.setCategory(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIncluded(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMax(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addAllowedExtraTickers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimit.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimit.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimit} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimit.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCategory();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getIncluded();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getMax();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getAllowedExtraTickersList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
};


/**
 * optional witbooking.backoffice.common.ExtraCategory category = 1;
 * @return {!proto.witbooking.backoffice.common.ExtraCategory}
 */
proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimit.prototype.getCategory = function() {
  return /** @type {!proto.witbooking.backoffice.common.ExtraCategory} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.witbooking.backoffice.common.ExtraCategory} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimit} returns this
 */
proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimit.prototype.setCategory = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional int32 included = 2;
 * @return {number}
 */
proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimit.prototype.getIncluded = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimit} returns this
 */
proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimit.prototype.setIncluded = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 max = 3;
 * @return {number}
 */
proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimit.prototype.getMax = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimit} returns this
 */
proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimit.prototype.setMax = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated string allowed_extra_tickers = 4;
 * @return {!Array<string>}
 */
proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimit.prototype.getAllowedExtraTickersList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimit} returns this
 */
proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimit.prototype.setAllowedExtraTickersList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimit} returns this
 */
proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimit.prototype.addAllowedExtraTickers = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimit} returns this
 */
proto.witbooking.backoffice.accommodation.v1.EngineCategoryLimit.prototype.clearAllowedExtraTickersList = function() {
  return this.setAllowedExtraTickersList([]);
};


/**
 * @enum {number}
 */
proto.witbooking.backoffice.accommodation.v1.CategoryExtraUnitType = {
  CATEGORY_EXTRA_UNIT_TYPE_UNSPECIFIED: 0,
  CATEGORY_EXTRA_UNIT_TYPE_PER_STAY: 1,
  CATEGORY_EXTRA_UNIT_TYPE_PER_NIGHT: 2
};

/**
 * @enum {number}
 */
proto.witbooking.backoffice.accommodation.v1.CategoryExtraRateType = {
  CATEGORY_EXTRA_RATE_TYPE_UNSPECIFIED: 0,
  CATEGORY_EXTRA_RATE_TYPE_PERCENTAGE: 1,
  CATEGORY_EXTRA_RATE_TYPE_FORMULA: 2,
  CATEGORY_EXTRA_RATE_TYPE_OWN: 3,
  CATEGORY_EXTRA_RATE_TYPE_SHARED: 4
};

goog.object.extend(exports, proto.witbooking.backoffice.accommodation.v1);
